import * as React from 'react';
import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { deserializeConnectionState } from 'app/area/case/draft/connected-state';
import { Bowtie } from './bowtie';
import { BowtieDisplayMode } from './external-types';
import { withRouter, WithRouterProps } from 'app/components/enhancers/with-router';
import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal';
import { Outlet, useOutletContext } from 'react-router-dom';
import { Draft } from 'app/area/case/draft';
import { CaseViewModalProvider, useCaseViewModal } from 'app/area/case/components/case-view-modal/case-view-modal-context';

interface BowtieParams {
  id: string;
}

const CaseWithRouter = withRouter(Case);
const DraftWithRouter = withRouter(Draft);

export const BowtieScreen: React.FC<React.PropsWithChildren<BowtieParams & WithRouterProps>> = (props) => {

  const caseNumber = safeNumericString(props.params.bowtieCaseId);
  const connectedDrafts = deserializeConnectionState(props.router.location.query);
  const instanceKey = useInstanceKey();

  if (caseNumber === '') {
    return null;
  }

  return (
    <div>
      <CaseViewModalProvider>      
        <Bowtie
        caseNumber={caseNumber}
        connectedDrafts={connectedDrafts}
        favouriteId={undefined}
        instanceKey={instanceKey}
        displayMode={BowtieDisplayMode.fullscreen}
      />
      <Outlet context={{ bowtieCaseId: caseNumber }} />
      </CaseViewModalProvider>
    </div>
  );
};

export const BowtieCaseModalContainer = () => {
  const { bowtieCaseId } = useOutletContext<{ bowtieCaseId: number }>();
  const context = useCaseViewModal();
  return (
    <CaseViewModal bowtieCaseId={bowtieCaseId} onClosedCallback={()=>{
      context.triggerModalClose();
    }} clearSearchParamsOnClose>
      <Outlet />
    </CaseViewModal>
  );
};

export const BowtieCaseView = () => {
  return (
    <CaseWithRouter />    
  );
};

export const BowtieCaseDraft = () => {
  return (
    <DraftWithRouter />
  );
};
